//Sono i listener che servono per comunicare con il gioco
export function allListener(game: any, caller: any){
    window.addEventListener('coin-changed', (e: any) => {
        console.log('Coin aggiornata nel gioco:', caller.coin, e.detail, caller.level); 
        caller.coin = e.detail;
            // ✅ aggiorna testo coin nel menu
        (window as any).UIBridge?.setCoinText((window as any).FORMATTER.formatCurrency(caller.coin, true)); 

        (window as any).UIBridge?.setBet((window as any).FORMATTER.formatCurrency(caller.level * caller.coin, true));
        
        caller.getBetMap();
        game.notifyBetUpdate(caller.betMap[0]);
    });

    window.addEventListener('sound-changed', (e: any) => {
        game.sound(e.detail);
    });

    window.addEventListener('bet-pressed', ()=>{
        game.UIButton(1);
    });

    window.addEventListener('change-language', (e: any) => {
        console.log('Cambio lingua:', e.detail);
        game.notifyLanguageChange(e.detail);
    });

    window.addEventListener('change-currency', (e: any) => {
        console.log('Valuta usata:', e.detail);
        game.notifyCurrencyChange(e.detail);
    });

    window.addEventListener('autoplay-enabled', (e: any) => {
        if( e.detail.enabled === true){
            game.UIButton(2, e.detail);
        }
        else if( e.detail.enabled === false){
            game.UIButton(2, e.detail);
        }
        //game.notifyBetUpdate(e.detail);
    });

    if((window as any).GENERAL_CONFIG.enabledRefreshBalance){
        window.addEventListener('message', function(event){
            if(event.data !== "refreshBalance") return;
            caller.refreshBalance()
        });
    }

    // ─── Global error handlers ────────────────────────────────────────────────────
    // Intercetta errori sincroni non catturati e li mostra come popup bloccante,
    window.onerror = (_message, _source, _lineno, _colno, _error) => {
        caller.rgs.transport.stopClientTimeout();
        game.pause(true);
        (window as any).UIBridge?.showPopupControl?.('popup.genericMessage', true, false, false, true);
        return true; // impedisce la gestione di default del browser
    };

    // Intercetta anche le Promise rifiutate senza catch
    window.addEventListener('unhandledrejection', () => {
        caller.rgs.transport.stopClientTimeout();
        game.pause(true);
        (window as any).UIBridge?.showPopupControl?.('popup.genericMessage', true, false, false, true);
    });
}

//Fullscreen listener presente nel mongibelloforgeutilities
export function fullscreenListener(){
    window.addEventListener('toggle-fullscreen', () => {
        const viewGame = document.getElementById('view-game');
        const target = viewGame ?? document.documentElement;

        if (!document.fullscreenElement) {
            target.requestFullscreen?.();
        } else {
            document.exitFullscreen?.();
        }
    });
}